module.exports = __webpack_public_path__ + "static/media/pink@3x.c20a512e.png";